import { useAuth } from "oidc-react";
import { isBeforeDate, isWithinDays, parseDE } from "../helper/dateHelper";

export function useLicense() {

    const auth = useAuth();

    let isInitialized = false;
    let isBeforeTarget = false;
    let isWithinLimit = false;

    let forceAllow = false;

    let licenseValidUntil: Date | null = null;

    if(auth.userData){
    
        try {
            const dateString = auth.userData?.profile.targetLicense as string;
            // const dateString = "01.12.2025";
            // const dateString = "";
    
            if(dateString != null && dateString.trim().length > 0){
                licenseValidUntil = parseDE(dateString);
            }
            else{
                // wenn keine Lizenz dann erstmal default Verhalten
                forceAllow = true;
            }
    
        } catch (error) {
            
        }

        if(licenseValidUntil != null){
            const now = new Date();
            const daysLimit = 30; // 🔧 change this value dynamically as needed
    
            isBeforeTarget = isBeforeDate(licenseValidUntil);
            isWithinLimit = isWithinDays(now, licenseValidUntil, daysLimit);
            
        }

        isInitialized = true;

        if(forceAllow){
            isBeforeTarget = true;
            isWithinLimit = false;
        }
    }



  return { isInitialized, isBeforeTarget, isWithinLimit, licenseValidUntil };
}